import { Action } from '@ngrx/store';

export enum OfferActionTypes {
  GET_OFFERS = '[Offers] GET',
  GET_OFFERS_SUCCESS = '[Offers] GET Success',
  GET_OFFERS_FAILURE = '[Offers] GET Failure',

  GET_OFFER = '[Offer] GET',
  GET_OFFER_SUCCESS = '[Offer] GET Success',
  GET_OFFER_FAILURE = '[Offer] GET Failure',

  SET_OFFER = '[Offer] SET Offer',
  SET_OFFER_SUCCESS = '[Offer] SET Offer Success',
  SET_OFFER_FAILURE = '[Offer] SET Offer Failure',

  GET_OFFER_TYPES = '[Offers] GET Offer Types',
  GET_OFFER_TYPES_SUCCESS = '[Offers] GET Offer Types Success',
  GET_OFFER_TYPES_FAILURE = '[Offers] GET Offer Types Failure',

  GET_INACTIVE_OFFER_TYPE = '[Offers] GET Inactive Offer Type',
  GET_INACTIVE_OFFER_TYPE_SUCCESS = '[Offers] GET Inactive Offer Type Success',
  GET_INACTIVE_OFFER_TYPE_FAILURE = '[Offers] GET Inactive Offer Type Failure',

  EDIT_OFFER = '[Offer] EDIT Offer',
  CREATE_OFFER = '[Offer] CREATE Offer',

  UPDATE_OFFER = '[Offer] UPDATE Offer',
  UPDATE_OFFER_SUCCESS = '[Offer] UPDATE Offer Success',
  UPDATE_OFFER_FAILURE = '[Offer] UPDATE Offer Failure',

  BATCH_UPDATE_OFFER = '[Offer] BATCH UPDATE Offer',
  BATCH_UPDATE_OFFER_SUCCESS = '[Offer] BATCH UPDATE Offer Success',
  BATCH_UPDATE_OFFER_FAILURE = '[Offer] BATCH UPDATE Offer Failure',


  INGEST_OFFERS = '[Offer] INGEST Offer',
  INGEST_OFFERS_SUCCESS = '[Offer] INGEST Offer Success',
  INGEST_OFFERS_FAILURE = '[Offer] INGEST Offer Failure',

  GET_FAVE_OFFERS = '[Offers] GET Favourites',
  GET_FAVE_OFFERS_SUCCESS = '[Offers] GET Favourites Success',
  GET_FAVE_OFFERS_FAILURE = '[Offers] GET Favourites Failure',

  UPDATE_FAVE_OFFERS = '[Offers] UPDATE Favourites',
  UPDATE_FAVE_OFFERS_SUCCESS = '[Offers] UPDATE Favourites Success',
  UPDATE_FAVE_OFFERS_FAILURE = '[Offers] UPDATE Favourites Failure',

  COPY_OFFER = '[Offer] COPY Offer',
  COPY_OFFER_SUCCESS = '[Offer] COPY Offer Success',
  COPY_OFFER_FAILURE = '[Offer] COPY Offer Failure',

  MOVE_OFFER = '[Offer] MOVE Offer',
  MOVE_OFFER_SUCCESS = '[Offer] MOVE Offer Success',
  MOVE_OFFER_FAILURE = '[Offer] MOVE Offer Failure',

  ASSIGN_OFFER = '[Offer] ASSIGN Offer',
  ASSIGN_OFFER_SUCCESS = '[Offer] ASSIGN Offer Success',
  ASSIGN_OFFER_FAILURE = '[Offer] ASSIGN Offer Failure',

  ALLOCATE_OFFER = '[Offer] ALLOCATE Offer',
  ALLOCATE_OFFER_SUCCESS = '[Offer] ALLOCATE Offer Success',
  ALLOCATE_OFFER_FAILURE = '[Offer] ALLOCATE Offer Failure',

  ALLOCATE_FAVE_OFFER = '[Offer] ALLOCATE Fave Offer',
  ALLOCATE_FAVE_OFFER_SUCCESS = '[Offer] ALLOCATE Fave Offer Success',
  ALLOCATE_FAVE_OFFER_FAILURE = '[Offer] ALLOCATE Fave Offer Failure',

  SWAP_OFFERS = '[Offer] SWAP Offers',
  SWAP_OFFERS_SUCCESS = '[Offer] SWAP Offers Success',
  SWAP_OFFERS_FAILURE = '[Offer] SWAP Offers Failure',

  MOVE_ALLOCATION = '[Alloc] Move Allocation',
  MOVE_ALLOCATION_SUCCESS = '[Alloc] Move Allocation Success',
  MOVE_ALLOCATION_FAILURE = '[Alloc] Move Allocation Failure',

  REMOVE_ALLOCATION = '[Alloc] Remove Allocation',
  REMOVE_ALLOCATION_SUCCESS = '[Alloc] Remove Allocation Success',
  REMOVE_ALLOCATION_FAILURE = '[Alloc] Remove Allocation Failure',

  SET_OFFER_LOCK = '[Offer] Set Lock',
  SET_OFFER_LOCK_SUCCESS = '[Offer] Set Lock Success',
  SET_OFFER_LOCK_FAILURE = '[Offer] Set Lock Failure',

  UNALLOCATE_OFFER = '[Offer] UNALLOCATE Offer',
  UNALLOCATE_OFFER_SUCCESS = '[Offer] UNALLOCATE Offer Success',
  UNALLOCATE_OFFER_FAILURE = '[Offer] UNALLOCATE Offer Failure',

  ADD_MEDIA = '[Offer] ADD Media',
  ADD_MEDIA_SUCCESS = '[Offer] ADD Media Success',
  ADD_MEDIA_FAILURE = '[Offer] ADD Media Failure',

  GET_OFFER_HISTORY = '[Offer] GET History',
  GET_OFFER_HISTORY_SUCCESS = '[Offer] GET History Success',
  GET_OFFER_HISTORY_FAILURE = '[Offer] GET History Failure',

  GET_HSS_CODES = '[Offer] GET HSSCodes',
  GET_HSS_CODES_SUCCESS = '[Offer] GET HSSCodes Success',
  GET_HSS_CODES_FAILURE = '[Offer] GET HSSCodes Failure',

  GET_ALT_FIELDS = '[Offer] GET Alt Fields',	
  GET_ALT_FIELDS_SUCCESS = '[Offer] GET Alt Fields Success',	
  GET_ALT_FIELDS_FAILURE = '[Offer] GET Alt Fields Failure',

  GET_FIELDS = '[Offer] GET Fields',
  GET_FIELDS_SUCCESS = '[Offer] GET Fields Success',
  GET_FIELDS_FAILURE = '[Offer] GET Fields Failure',

  GET_PREFERENCES = '[Offers] GET Preferences',	
  GET_PREFERENCES_SUCCESS = '[Offers] GET Preferences Success',	
  GET_PREFERENCES_FAILURE = '[Offers] GET Preferences Failure',

  // GET_COMPANY = '[Offer] GET Company',
  // GET_COMPANY_SUCCESS = '[Offer] GET Company Success',
  // GET_COMPANY_FAILURE = '[Offer] GET Company Failure',

}

// OFFERS
export class GetOffers implements Action {
  readonly type = OfferActionTypes.GET_OFFERS;
  constructor(public payload: any) {}
}
export class GetOffersSuccess implements Action {
  readonly type = OfferActionTypes.GET_OFFERS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOffersFailure implements Action {
  readonly type = OfferActionTypes.GET_OFFERS_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateOffer implements Action {
  readonly type = OfferActionTypes.UPDATE_OFFER;
  constructor(public payload: any) {}
}
export class UpdateOfferSuccess implements Action {
  readonly type = OfferActionTypes.UPDATE_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateOfferFailure implements Action {
  readonly type = OfferActionTypes.UPDATE_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class BatchUpdateOffer implements Action {
  readonly type = OfferActionTypes.BATCH_UPDATE_OFFER;
  constructor(public payload: any) {}
}
export class BatchUpdateOfferSuccess implements Action {
  readonly type = OfferActionTypes.BATCH_UPDATE_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class BatchUpdateOfferFailure implements Action {
  readonly type = OfferActionTypes.BATCH_UPDATE_OFFER_FAILURE;
  constructor(public payload: any) {}
}

// OFFER
export class EditOffer implements Action {
  readonly type = OfferActionTypes.EDIT_OFFER;
  constructor(public payload: any) {}
}
export class CreateOffer implements Action {
  readonly type = OfferActionTypes.CREATE_OFFER;
  constructor(public payload: any) {}
}
export class SetOffer implements Action {
  readonly type = OfferActionTypes.SET_OFFER;
  constructor(public payload: any) {}
}
export class SetOfferSuccess implements Action {
  readonly type = OfferActionTypes.SET_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class SetOfferFailure implements Action {
  readonly type = OfferActionTypes.SET_OFFER_FAILURE;
  constructor(public payload: any) {}
}
export class GetOffer implements Action {
  readonly type = OfferActionTypes.GET_OFFER;
  constructor(public payload: any) {}
}
export class GetOfferSuccess implements Action {
  readonly type = OfferActionTypes.GET_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOfferFailure implements Action {
  readonly type = OfferActionTypes.GET_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class CopyOffer implements Action {
  readonly type = OfferActionTypes.COPY_OFFER;
  constructor(public payload: any) {}
}
export class CopyOfferSuccess implements Action {
  readonly type = OfferActionTypes.COPY_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class CopyOfferFailure implements Action {
  readonly type = OfferActionTypes.COPY_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class MoveOffer implements Action {
  readonly type = OfferActionTypes.MOVE_OFFER;
  constructor(public payload: any) {}
}
export class MoveOfferSuccess implements Action {
  readonly type = OfferActionTypes.MOVE_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class MoveOfferFailure implements Action {
  readonly type = OfferActionTypes.MOVE_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class AssignOffer implements Action {
  readonly type = OfferActionTypes.ASSIGN_OFFER;
  constructor(public payload: any) {}
}
export class AssignOfferSuccess implements Action {
  readonly type = OfferActionTypes.ASSIGN_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignOfferFailure implements Action {
  readonly type = OfferActionTypes.ASSIGN_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class AllocateOffer implements Action {
  readonly type = OfferActionTypes.ALLOCATE_OFFER;
  constructor(public payload: any) {}
}
export class AllocateOfferSuccess implements Action {
  readonly type = OfferActionTypes.ALLOCATE_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class AllocateOfferFailure implements Action {
  readonly type = OfferActionTypes.ALLOCATE_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class AllocateFaveOffer implements Action {
  readonly type = OfferActionTypes.ALLOCATE_FAVE_OFFER;
  constructor(public payload: any) {}
}
export class AllocateFaveOfferSuccess implements Action {
  readonly type = OfferActionTypes.ALLOCATE_FAVE_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class AllocateFaveOfferFailure implements Action {
  readonly type = OfferActionTypes.ALLOCATE_FAVE_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class IngestOffers implements Action {
  readonly type = OfferActionTypes.INGEST_OFFERS;
  constructor(public payload: any) {}
}
export class IngestOffersSuccess implements Action {
  readonly type = OfferActionTypes.INGEST_OFFERS_SUCCESS;
  constructor(public payload: any) {}
}
export class IngestOffersFailure implements Action {
  readonly type = OfferActionTypes.INGEST_OFFERS_FAILURE;
  constructor(public payload: any) {}
}

export class GetFaveOffers implements Action {
  readonly type = OfferActionTypes.GET_FAVE_OFFERS;
  constructor(public payload: any) {}
}
export class GetFaveOffersSuccess implements Action {
  readonly type = OfferActionTypes.GET_FAVE_OFFERS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFaveOffersFailure implements Action {
  readonly type = OfferActionTypes.GET_FAVE_OFFERS_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateFaveOffers implements Action {
  readonly type = OfferActionTypes.UPDATE_FAVE_OFFERS;
  constructor(public payload: any) {}
}
export class UpdateFaveOffersSuccess implements Action {
  readonly type = OfferActionTypes.UPDATE_FAVE_OFFERS_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateFaveOffersFailure implements Action {
  readonly type = OfferActionTypes.UPDATE_FAVE_OFFERS_FAILURE;
  constructor(public payload: any) {}
}

export class SwapOffers implements Action {
  readonly type = OfferActionTypes.SWAP_OFFERS;
  constructor(public payload: any) {}
}
export class SwapOffersSuccess implements Action {
  readonly type = OfferActionTypes.SWAP_OFFERS_SUCCESS;
  constructor(public payload: any) {}
}
export class SwapOffersFailure implements Action {
  readonly type = OfferActionTypes.SWAP_OFFERS_FAILURE;
  constructor(public payload: any) {}
}

export class GetOfferTypes implements Action {
  readonly type = OfferActionTypes.GET_OFFER_TYPES;
  constructor(public payload: any) {}
}
export class GetOfferTypesSuccess implements Action {
  readonly type = OfferActionTypes.GET_OFFER_TYPES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOfferTypesFailure implements Action {
  readonly type = OfferActionTypes.GET_OFFER_TYPES_FAILURE;
  constructor(public payload: any) {}
}

export class GetInactiveOfferType implements Action {
  readonly type = OfferActionTypes.GET_INACTIVE_OFFER_TYPE;
  constructor(public payload: any) {}
}
export class GetInactiveOfferTypeSuccess implements Action {
  readonly type = OfferActionTypes.GET_INACTIVE_OFFER_TYPE_SUCCESS;
  constructor(public payload: any) {}
}
export class GetInactiveOfferTypeFailure implements Action {
  readonly type = OfferActionTypes.GET_INACTIVE_OFFER_TYPE_FAILURE;
  constructor(public payload: any) {}
}

export class MoveAllocation implements Action {
  readonly type = OfferActionTypes.MOVE_ALLOCATION;
  constructor(public payload: any) {}
}
export class MoveAllocationSuccess implements Action {
  readonly type = OfferActionTypes.MOVE_ALLOCATION_SUCCESS;
  constructor(public payload: any) {}
}
export class MoveAllocationFailure implements Action {
  readonly type = OfferActionTypes.MOVE_ALLOCATION_FAILURE;
  constructor(public payload: any) {}
}

export class RemoveAllocation implements Action {
  readonly type = OfferActionTypes.REMOVE_ALLOCATION;
  constructor(public payload: any) {}
}
export class RemoveAllocationSuccess implements Action {
  readonly type = OfferActionTypes.REMOVE_ALLOCATION_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveAllocationFailure implements Action {
  readonly type = OfferActionTypes.REMOVE_ALLOCATION_FAILURE;
  constructor(public payload: any) {}
}

export class SetOfferLock implements Action {
  readonly type = OfferActionTypes.SET_OFFER_LOCK;
  constructor(public payload: any) {}
}
export class SetOfferLockSuccess implements Action {
  readonly type = OfferActionTypes.SET_OFFER_LOCK_SUCCESS;
  constructor(public payload: any) {}
}
export class SetOfferLockFailure implements Action {
  readonly type = OfferActionTypes.SET_OFFER_LOCK_FAILURE;
  constructor(public payload: any) {}
}

export class UnallocateOffer implements Action {
  readonly type = OfferActionTypes.UNALLOCATE_OFFER;
  constructor(public payload: any) {}
}
export class UnallocateOfferSuccess implements Action {
  readonly type = OfferActionTypes.UNALLOCATE_OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class UnallocateOfferFailure implements Action {
  readonly type = OfferActionTypes.UNALLOCATE_OFFER_FAILURE;
  constructor(public payload: any) {}
}

export class AddMedia implements Action {
  readonly type = OfferActionTypes.ADD_MEDIA;
  constructor(public payload: any) {}
}
export class AddMediaSuccess implements Action {
  readonly type = OfferActionTypes.ADD_MEDIA_SUCCESS;
  constructor(public payload: any) {}
}
export class AddMediaFailure implements Action {
  readonly type = OfferActionTypes.ADD_MEDIA_FAILURE;
  constructor(public payload: any) {}
}


export class GetOfferHistory implements Action {
  readonly type = OfferActionTypes.GET_OFFER_HISTORY;
  constructor(public payload: any) {}
}
export class GetOfferHistorySuccess implements Action {
  readonly type = OfferActionTypes.GET_OFFER_HISTORY_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOfferHistoryFailure implements Action {
  readonly type = OfferActionTypes.GET_OFFER_HISTORY_FAILURE;
  constructor(public payload: any) {}
}

export class GetHSSCodes implements Action {
  readonly type = OfferActionTypes.GET_HSS_CODES;
  constructor(public payload: any) {}
}
export class GetHSSCodesSuccess implements Action {
  readonly type = OfferActionTypes.GET_HSS_CODES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetHSSCodesFailure implements Action {
  readonly type = OfferActionTypes.GET_HSS_CODES_FAILURE;
  constructor(public payload: any) {}
}

export class GetAltFields implements Action {	
  readonly type = OfferActionTypes.GET_ALT_FIELDS;	
  constructor(public payload: any) {}	
}	
export class GetAltFieldsSuccess implements Action {	
  readonly type = OfferActionTypes.GET_ALT_FIELDS_SUCCESS;	
  constructor(public payload: any) {}	
}	
export class GetAltFieldsFailure implements Action {	
  readonly type = OfferActionTypes.GET_ALT_FIELDS_FAILURE;	
  constructor(public payload: any) {}	
}

export class GetFields implements Action {
  readonly type = OfferActionTypes.GET_FIELDS;
  constructor(public payload: any) {}
}
export class GetFieldsSuccess implements Action {
  readonly type = OfferActionTypes.GET_FIELDS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFieldsFailure implements Action {
  readonly type = OfferActionTypes.GET_FIELDS_FAILURE;
  constructor(public payload: any) {}
}

// Company Preferences
export class GetPreferences implements Action {	
  readonly type = OfferActionTypes.GET_PREFERENCES;	
  constructor(public payload: any) {}	
}	
export class GetPreferencesSuccess implements Action {	
  readonly type = OfferActionTypes.GET_PREFERENCES_SUCCESS;	
  constructor(public payload: any) {}	
}	
export class GetPreferencesFailure implements Action {	
  readonly type = OfferActionTypes.GET_PREFERENCES_FAILURE;	
  constructor(public payload: any) {}	
}


export type All =
  | GetOffers
  | GetOffersSuccess
  | GetOffersFailure
  | UpdateOffer
  | UpdateOfferSuccess
  | UpdateOfferFailure
  | BatchUpdateOffer
  | BatchUpdateOfferSuccess
  | BatchUpdateOfferFailure
  | EditOffer
  | CreateOffer
  | SetOffer
  | SetOfferSuccess
  | SetOfferFailure
  | GetOffer
  | GetOfferSuccess
  | GetOfferFailure
  | GetOfferTypes
  | GetOfferTypesSuccess
  | GetOfferTypesFailure
  | GetInactiveOfferType
  | GetInactiveOfferTypeSuccess
  | GetInactiveOfferTypeFailure
  | CopyOffer
  | CopyOfferSuccess
  | CopyOfferFailure
  | MoveOffer
  | MoveOfferSuccess
  | MoveOfferFailure
  | AssignOffer
  | AssignOfferSuccess
  | AssignOfferFailure
  | AllocateOffer
  | AllocateOfferSuccess
  | AllocateOfferFailure
  | AllocateFaveOffer
  | AllocateFaveOfferSuccess
  | AllocateFaveOfferFailure
  | IngestOffers
  | IngestOffersSuccess
  | IngestOffersFailure
  | GetFaveOffers
  | GetFaveOffersSuccess
  | GetFaveOffersFailure
  | UpdateFaveOffers
  | UpdateFaveOffersSuccess
  | UpdateFaveOffersFailure
  | SwapOffers
  | SwapOffersSuccess
  | SwapOffersFailure
  | MoveAllocation
  | MoveAllocationSuccess
  | MoveAllocationFailure
  | RemoveAllocation
  | RemoveAllocationSuccess
  | RemoveAllocationFailure
  | SetOfferLock
  | SetOfferLockSuccess
  | SetOfferLockFailure
  | UnallocateOffer
  | UnallocateOfferSuccess
  | UnallocateOfferFailure
  | AddMedia
  | AddMediaSuccess
  | AddMediaFailure
  | GetOfferHistory
  | GetOfferHistorySuccess
  | GetOfferHistoryFailure
  | GetHSSCodes
  | GetHSSCodesSuccess
  | GetHSSCodesFailure
  | GetAltFields	
  | GetAltFieldsSuccess	
  | GetAltFieldsFailure
  | GetFields
  | GetFieldsSuccess
  | GetFieldsFailure
  | GetPreferences	
  | GetPreferencesSuccess	
  | GetPreferencesFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/offer.actions.ts